import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@/store/store";
import type { Role } from "./accountConstants";

type Account = {
  accountId?: number;
  roles?: Role[];
  [key: string]: any;
};

const initialState: Account = {};

const slice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setData: (_state, action: PayloadAction<Account>) => {
      return action.payload;
    },
  },
});

// selectors
const selectSelf = (state: RootState): Account => state.currentAccount;

export const accountSelectors = {
  selectAccountId: (state: RootState): number | undefined =>
    selectSelf(state).accountId,
  selectRoles: (state: RootState): Role[] => selectSelf(state).roles ?? [],
  selectCurrentAccount: selectSelf,
};

// actions
export const accountActions = slice.actions;

// reducer
export const reducer = slice.reducer;
